export default __webpack_public_path__ + "static/media/test1.af0f7e6b.png";